<mat-card class="widget">
    <div class="topbg">
        <div class="polygon-bg"></div>

        <img class="sub-image" [src]="subscription?.image" [alt]="subscription?.name + ' image'"/>

        <div class="price">
            <img class="period-image" [src]="subscriptionPeriodImage"/>
            <p>{{ priceText }}</p>
        </div>
    </div>

    <div class="top"></div>

    <div class="bottom">
        <div class="features-wrap">
            <h3>{{ 'general.become' | translate }} {{ ('subscription.name.' + subscription?.name.toLowerCase()) | translate | lowercase }}</h3>
            
            @if(subscription.isExtra && subscription.features && subscription.features.length > 0) {
                <div class="extra-role-explanation">
                    <img src="assets/images/lamp.png"/>
                    <p>{{ 'subscription.extra_role_explanation' | translate }}</p>
                </div>
            }
            
            <div class="features">
                @if(subscription.features && subscription.features.length > 0) {
                    @for (feature of subscription.features; track $index) {
                        <div class="feature">
                            <div class="icon">
                                <mat-icon class="check">checkmark</mat-icon>
                            </div>
                            <p>{{ feature }}</p>
                        </div>
                    }
                } @else {
                    <div class="feature">
                        <div class="icon">
                            <mat-icon class="cancel">close</mat-icon>
                        </div>
                        <p>{{ 'subscription.not_available' | translate }}</p>
                    </div>
                }
            </div>
        </div>

        @if (subscription.isExtra) {
            <button 
                class="contact-button button-margin" 
                mat-flat-button 
                color="primary"
                [disabled]="
                    !subscription.features 
                    || subscription.features.length < 1 
                    || (isUnderAge && subscription.hasAgeRequirement)
                    || extraOwned" 
                [title]="'subscription.contact' | translate | uppercase"
                (click)="contact()"
            >
                {{ extraOwned 
                    ? ('subscription.owned' | translate | uppercase) 
                    : isUnderAge && subscription.hasAgeRequirement 
                        ? ('subscription.not_allowed_underage' | translate: { age: ageRequirement } | uppercase) 
                        : ('subscription.contact' | translate | uppercase)
                }}
            </button>
        } @else {
            <button 
                class="sub-button button-margin" 
                mat-flat-button 
                [disabled]="
                    !subscription.features 
                    || subscription.features.length < 1 
                    || !this.subscription.buyUrl
                    || (isUnderAge && subscription.hasAgeRequirement)
                    || (subscription.name.toLowerCase() === 'scout' && !isUnderAge)
                    || subscription.id === activeSubscriptionId" 
                [title]="'general.subscribe' | translate | uppercase"
                (click)="subscribe()"
            >
                {{ 
                    subscription.id === activeSubscriptionId 
                    ? ('subscription.owned' | translate | uppercase) 
                    : isUnderAge && subscription.hasAgeRequirement
                        ? ('subscription.not_allowed_underage' | translate: { age: ageRequirement } | uppercase) 
                        : subscription.name.toLowerCase() === "scout" && !isUnderAge
                            ? ('subscription.not_allowed_above_age' | translate: { age: ageRequirement } | uppercase) 
                            : ('general.subscribe' | translate | uppercase) 
                }}
            </button>
        }
    </div>
</mat-card>